import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toc"
export default class extends Controller {
	static targets = ["item", "content"]

	initialize() {
		// Set id attribute to h4 / h5 headers within trix-content
		this.trixContent = document.querySelector(".trix-content")
		this.setHeaderIds()
	}

	connect() {
		this._setLinkScroll()
	}

	setHeaderIds() {
		const headers = this.trixContent.querySelectorAll('h4, h5, h6'); // Select toc header types
		headers.forEach((header, index) => {
			const id = `header-${index + 1}`; // Create a unique ID like "header-1", "header-2"
			header.setAttribute('id', id);
		});
	}

	_setLinkScroll() {
		this.itemTargets.forEach((item) => {
			item.addEventListener("click", (e) => {
				e.preventDefault();
				const target = this.contentTarget.querySelector(
					e.target.getAttribute("href")
				);
				target?.scrollIntoView({ behavior: "smooth", block: "start" });
			});
		});
	}
}